module.exports = __webpack_public_path__ + "img/excelSmall.5e95079b.png";